import * as React from 'react';

import { CircleSpinner } from '@blockworks/ui/legacy/loaders';

import Breadcrumb from '@/components/display/headers/breadcrumb';
import type { Category } from '@/utils/functions/wordpress/fetch-categories';
import NewsArchiveCtx from '@/context/news-archive-ctx';
import FilterIcon from '@/assets/icons/filter-icon';

import NewsCategoryTabs from './categories/news-category-tabs';

// Sort Input data
const sortOptions = [{ id: 123, name: 'Date', orderBy: 'date', direction: 'desc' }];

type HeaderProps = {
    // Data
    categories: Category[];
    authors: any;
    tags: Category[];
    showLoader: boolean;
};

const SectionHeader = (props: HeaderProps) => {
    const {
        // Data
        categories,
        authors,
        tags,
        showLoader,
    } = props;

    const newsArchiveCtx = React.useContext(NewsArchiveCtx);
    const { clearAllFilters, showFilterUI } = newsArchiveCtx;

    return (
        <div className="w-full">
            <div className="p-12 border-b">
                <Breadcrumb
                    items={[
                        {
                            title: 'News',
                            link: '/news',
                        },
                    ]}
                />
                <div className="">
                    <h1 className="self-stretch w-full text-5xl font-semibold text-left text-[#110b29]">News</h1>
                </div>
            </div>
            <div>
                <div className="flex flex-row border-b">
                    <div className="pl-8 flex items-center gap-0 text-light-gray pr-0 md:pr-8 md:border-r border-light-gray/35">
                        <FilterIcon
                            className="text-light-gray hover:text-black aria-hidden=true cursor-pointer mr-2"
                            style={'gray'}
                            width={12}
                            height={12}
                        />
                        <span className="block uppercase text-inherit font-light text-[14px]">Filters</span>
                    </div>
                    <NewsCategoryTabs
                        // Data
                        categories={categories}
                        tags={tags}
                        authors={authors}
                        sort={sortOptions}
                    />
                    <div className="flex flex-grow items-center gap-0 text-light-gray pl-0 md:pl-8 md:border-l border-light-gray/35">
                        {showFilterUI && (
                            <div className="flex items-center gap-0">
                                <button
                                    className="block uppercase text-inherit font-light text-[14px] hover:text-black"
                                    onClick={clearAllFilters}
                                >
                                    Clear all
                                </button>
                            </div>
                        )}
                    </div>
                    <div className="p-5">{showLoader && <CircleSpinner />}</div>
                </div>
            </div>
        </div>
    );
};

export default SectionHeader;
